export const AnalyticsConstants = {
  events: {
    authDeleteAccount: "auth_delete_account",
    authForgotPasswordOpened: "auth_forgot_password_opened",
    authLogout: "auth_logout",
    authPasswordVisibilityToggled: "auth_password_visibility_toggled",
    authSubmit: "auth_submit",
    bonusSwipesActivated: "bonus_swipes_activated",
    characterConnected: "character_connected",
    characterDeckStarted: "character_deck_started",
    characterDetailViewed: "character_detail_viewed",
    characterDisconnected: "character_disconnected",
    characterDiscoverCtaTapped: "character_discover_cta_tapped",
    characterDiscoverInfoOpened: "character_discover_info_opened",
    characterDiscoverViewed: "character_discover_viewed",
    characterMatchHealed: "character_match_healed",
    characterMatchHeld: "character_match_held",
    characterMatchInstant: "character_match_instant",
    characterMatchRevealed: "character_match_revealed",
    characterMatchesViewed: "character_matches_viewed",
    characterNotificationOpened: "character_notification_opened",
    characterStoryClosed: "character_story_closed",
    characterStoryOpened: "character_story_opened",
    characterStoryShown: "character_story_shown",
    characterTileTapped: "character_tile_tapped",
    coupleUnlockActivated: "couple_unlock_activated",
    coupleUnlockRevoked: "couple_unlock_revoked",
    deckAllowanceStripTapped: "deck_allowance_strip_tapped",
    deckCatalogExhausted: "deck_catalog_exhausted",
    deckSuperlikePaywallOpened: "deck_superlike_paywall_opened",
    deckSwipe: "deck_swipe",
    extraSwipesExplainerDismissed: "extra_swipes_explainer_dismissed",
    extraSwipesExplainerShown: "extra_swipes_explainer_shown",
    experimentExposure: "experiment_exposure",
    matchCardOpened: "match_card_opened",
    matchesOpened: "matches_opened",
    noPartnerConnectCtaTapped: "no_partner_connect_cta_tapped",
    notificationLinkOpened: "notification_link_opened",
    notificationsBannerAction: "notifications_banner_action",
    notificationsBannerDismissed: "notifications_banner_dismissed",
    notificationsBannerShown: "notifications_banner_shown",
    onboardingGenderSubmitted: "onboarding_gender_submitted",
    onboardingNameSubmitted: "onboarding_name_submitted",
    onboardingProfilePhotoAction: "onboarding_profile_photo_action",
    onboardingPushPermissionChoice: "onboarding_push_permission_choice",
    partnerActivityNotificationOpened: "partner_activity_notification_opened",
    partnerAllCardsNotificationOpened: "partner_all_cards_notification_opened",
    partnerDisconnectConfirmed: "partner_disconnect_confirmed",
    partnerDisconnectRequested: "partner_disconnect_requested",
    partnerInvitationSent: "partner_invitation_sent",
    partnerPlayModeSelected: "partner_play_mode_selected",
    partnerRequestAction: "partner_request_action",
    paywallCtaTapped: "paywall_cta_tapped",
    paywallCtaViewed: "paywall_cta_viewed",
    purchaseSubmitted: "purchase_submitted",
    pushTokenRegistered: "push_token_registered",
    settingsEmailToggled: "settings_email_toggled",
    settingsProfileUpdated: "settings_profile_updated",
    settingsPushEnableAttempted: "settings_push_enable_attempted",
    storeReviewFeedbackSubmitted: "store_review_feedback_submitted",
    storeReviewPromptShown: "store_review_prompt_shown",
    storeReviewRequestAttempted: "store_review_request_attempted",
    swipesSheetClosed: "swipes_sheet_closed",
    swipesSheetOpened: "swipes_sheet_opened",
    swipesSheetPurchaseTapped: "swipes_sheet_purchase_tapped",
  },
  params: {
    action: "action",
    allCardsUnlocked: "all_cards_unlocked",
    cardId: "card_id",
    cardType: "card_type",
    channel: "channel",
    characterId: "character_id",
    characterUnlockOffered: "character_unlock_offered",
    connectedCount: "connected_count",
    count: "count",
    coupleUnlockOffered: "couple_unlock_offered",
    dailyCardsVariant: "daily_cards_variant",
    deckType: "deck_type",
    delaySeconds: "delay_seconds",
    direction: "direction",
    droppedCount: "dropped_count",
    durationMs: "duration_ms",
    enabled: "enabled",
    entryScreen: "entry_screen",
    errorCause: "error_cause",
    experiment: "experiment",
    extraSwipesAvailable: "extra_swipes_available",
    field: "field",
    fromMode: "from_mode",
    hadAllCardsUnlock: "had_all_cards_unlock",
    hadExistingPhoto: "had_existing_photo",
    hadNewBadge: "had_new_badge",
    hasStory: "has_story",
    hasValue: "has_value",
    heldCount: "held_count",
    initialIndex: "initial_index",
    isConnected: "is_connected",
    matchedCount: "matched_count",
    messageCount: "message_count",
    messagesShown: "messages_shown",
    mode: "mode",
    nameLength: "name_length",
    notificationResult: "notification_result",
    notificationType: "notification_type",
    nowVisible: "now_visible",
    openContext: "open_context",
    partnerCodeLength: "partner_code_length",
    partnerId: "partner_id",
    partnershipId: "partnership_id",
    paymentMethod: "payment_method",
    paymentProvider: "payment_provider",
    permissionEnabled: "permission_enabled",
    platform: "platform",
    position: "position",
    productId: "product_id",
    productType: "product_type",
    regularCardsRemaining: "regular_cards_remaining",
    result: "result",
    selectedGender: "selected_gender",
    selectedNewPhoto: "selected_new_photo",
    sendResult: "send_result",
    soloUnlockOffered: "solo_unlock_offered",
    source: "source",
    sourceScreen: "source_screen",
    step: "step",
    storyCount: "story_count",
    submitSource: "submit_source",
    superlikesAvailable: "superlikes_available",
    totalCards: "total_cards",
    trigger: "trigger",
    triggeredBy: "triggered_by",
    unlockPurchasedByMe: "unlock_purchased_by_me",
    validationResult: "validation_result",
    variant: "variant",
    warningCopy: "warning_copy",
    wasAlreadyConnected: "was_already_connected",
    wasAlreadySelected: "was_already_selected",
  },
  values: {
    actions: {
      accept: "accept",
      allow: "allow",
      characterTap: "character_tap",
      close: "close",
      continue: "continue",
      cta: "cta",
      deleteAccount: "delete_account",
      enable: "enable",
      logout: "logout",
      openSettings: "open_settings",
      reject: "reject",
      screenBlur: "screen_blur",
      skip: "skip",
    },
    // Which delivery channel produced a notification deep link: email CTAs
    // carry src=email, web push links carry no src.
    channels: {
      email: "email",
      push: "push",
    },
    entryScreens: {
      deck: "Deck",
      superlikePaywall: "SuperlikePaywall",
      swipesSheet: "SwipesSheet",
    },
    fields: {
      gender: "gender",
      name: "name",
      photo: "photo",
    },
    modes: {
      character: "character",
      login: "login",
      partner: "partner",
      solo: "solo",
    },
    // Web cannot schedule local notifications for held-match reveals, so the
    // RN outcomes (scheduled/cap_reached/permission_denied) are unreachable
    // here — every web hold reports 'unsupported' instead.
    // A held character match is queued server-side; the backend scheduler
    // sends the reveal push/email, so the app never reports a local outcome.
    notificationResults: {
      queued: "queued",
    },
    // Carried on the `notification_type` param of notification_link_opened:
    // the deep link's `notif` value, normalized; anything unrecognized (or an
    // untyped legacy link) reports `unknown`.
    notificationTypes: {
      acceptedRequest: "accepted_request",
      characterMatch: "character_match",
      matches: "matches",
      partnerAllCardsUnlocked: "partner_all_cards_unlocked",
      partnerDeckActivity: "partner_deck_activity",
      request: "request",
      superlike: "superlike",
      unknown: "unknown",
    },
    productTypes: {
      characterUnlock: "character_unlock",
      coupleUnlock: "couple_unlock",
      extraSwipes: "extra_swipes",
      inApp: "in_app",
      soloUnlock: "solo_unlock",
      superlikes: "superlikes",
    },
    experiments: {
      dailyCards: "daily_cards",
    },
    results: {
      alreadyEnabled: "already_enabled",
      attempted: "attempted",
      blockedPaywall: "blocked_paywall",
      cancelled: "cancelled",
      confirmed: "confirmed",
      declined: "declined",
      error: "error",
      granted: "granted",
      // Web divergence from RN's `opened_settings`: a browser cannot be
      // deep-linked into its site settings, so the `denied` state shows
      // manual instructions instead.
      instructionsShown: "instructions_shown",
      notFound: "not_found",
      opened: "opened",
      success: "success",
      validationError: "validation_error",
    },
    sendResults: {
      connected: "connected",
      error: "error",
      requestSent: "request_sent",
      validationError: "validation_error",
    },
    sources: {
      characterDetail: "character_detail",
      characterMatchNotification: "character_match_notification",
      discoverGrid: "discover_grid",
      headerButton: "header_button",
      match: "match",
      matchedCardDetail: "matched_card_detail",
      matchesList: "matches_list",
      matchesMenu: "matches_menu",
      newMatchesBanner: "new_matches_banner",
      notificationsBanner: "notifications_banner",
      partnerActivityNotification: "partner_activity_notification",
      partnerAllCardsNotification: "partner_all_cards_notification",
      partnerRow: "partner_row",
      settings: "settings",
      storyOverlay: "story_overlay",
      swipesSheet: "swipes_sheet",
    },
    sourceScreens: {
      characterDetail: "CharacterDetail",
      discoverCharacters: "DiscoverCharacters",
      noPartnerMatches: "NoPartnerMatches",
      partners: "Partners",
    },
    steps: {
      gender: "gender",
      name: "name",
      profilePhoto: "profile_photo",
      pushNotifications: "push_notifications",
    },
    // Carried on the `open_context` param. Deliberately NOT `mode` — that one is
    // reserved for the play mode (character/solo/partner), and both appear
    // together on the story events.
    storyContexts: {
      match: "match",
      reread: "reread",
    },
    triggers: {
      appActive: "app_active",
      cell: "cell",
      deck: "deck",
      matches: "matches",
      partners: "partners",
      switch: "switch",
    },
    validationResults: {
      invalid: "invalid",
      valid: "valid",
    },
    // Which disconnect-warning copy the user actually saw: base (no unlock),
    // unlock (loss warning included), degraded (unlock read failed).
    warningCopies: {
      base: "base",
      degraded: "degraded",
      unlock: "unlock",
    },
  },
  // Firebase user properties. Names are capped at 24 chars and values at 36 by
  // GA4; these segment every event in the property, not just the ones below.
  userProperties: {
    characterCount: "character_count",
    dailyCardsVariant: "exp_daily_cards",
    hasAllCardsUnlock: "has_all_cards_unlock",
    playMode: "play_mode",
    selectedCharacter: "selected_character",
  },
  parity: {
    // Web now receives FCM web push (banner, onboarding step, Settings row,
    // notification deep links all have web counterparts). Only LOCAL
    // notifications stay excluded: the character-match reveal is scheduled
    // on-device by notifee, which has no web analogue in v1.
    // The RN confirm-callable events have no SegPay counterpart either: the
    // web grant is a server-side postback with nothing client-observable per
    // attempt.
    excludedRnEvents: [
      // Mobile-push-grant email auto-disable has no web analogue — web
      // tokens never suppress email.
      "email_auto_disable_applied",
      // RevenueCat confirm/grant callable flow (RN-only)
      "purchase_confirm_result",
      "purchase_grant_result",
    ] as const,
  },
} as const;
